import React from 'react'
import { Server, ServerSettingsFormValue } from '.'
import { AgentFeature } from '../agent-features'
import { ServerSettingsFormSingleView } from './server-settings-form-single-view'
import { ServerSettingsFormSingleStateManager } from './server-settings-form-single-state-manager'

export function ServerSettingsFormSingle({
  isOpen,
  onCancel,
  onConfirm,
  isReadOnly,
  ...props
}: {
  server: Server
  onCancel: () => void
  onConfirm: (value: ServerSettingsFormValue) => void
  userIsProtect: boolean
  agentFeatures: AgentFeature[]
  isFreemium: boolean
  isOpen: boolean
  isReadOnly?: boolean
}) {
  return (
    <ServerSettingsFormSingleStateManager {...props}>
      {({ reset: resetState, updateSyslog, ...stateMgrProps }) => (
        <ServerSettingsFormSingleView
          {...stateMgrProps}
          isReadOnly={isReadOnly}
          isOpen={isOpen}
          onCancel={() => {
            onCancel()
            resetState()
          }}
          onConfirm={() => {
            onConfirm(stateMgrProps.formValue)
          }}
          syslogOnChange={updateSyslog}
        />
      )}
    </ServerSettingsFormSingleStateManager>
  )
}
